/* Archetype sort list (Kevin 2026-10-31).
   Replaces the phone's or browser's own picker for "Sort by" with our list, in the swatch tray's style.
   The theme's real <select> stays on the page (hidden) and still does the sorting: our list reads its options
   on every load and passes the choice back to it, so new or renamed sort options from Shopify appear by
   themselves and sorting works exactly as before. If this file fails to load, the normal select is still there. */
(function () {
  var SEL = 'select.facet-filters__sort, .mobile-facets__sort select';
  var CARET = '<svg viewBox="0 0 10 6" aria-hidden="true" focusable="false"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg>';
  var openOne = null;

  function close(w, focusBtn) {
    if (!w || w.list.hidden) return;
    w.list.hidden = true;
    w.box.classList.remove('is-open');
    w.btn.setAttribute('aria-expanded', 'false');
    if (focusBtn) w.btn.focus({ preventScroll: true });
    if (openOne === w) openOne = null;
  }

  function build(select) {
    if (select.dataset.afSort) return;
    var holder = select.closest('.select');
    if (!holder || !holder.parentNode) return;
    select.dataset.afSort = '1';
    var box = document.createElement('div');
    box.className = 'af-sort';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'af-sort__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    var lab = document.querySelector('label[for="' + select.id + '"]');
    btn.setAttribute('aria-label', (lab ? lab.textContent.replace(':', '').trim() : 'Sort by'));
    var txt = document.createElement('span');
    btn.appendChild(txt);
    btn.insertAdjacentHTML('beforeend', CARET);
    var list = document.createElement('ul');
    list.className = 'af-sort__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    box.appendChild(btn);
    box.appendChild(list);
    holder.parentNode.insertBefore(box, holder.nextSibling);
    holder.parentNode.classList.add('af-sort-ready');

    var w = { box: box, btn: btn, list: list };
    var opts = function () { return Array.prototype.slice.call(list.querySelectorAll('[role="option"]')); };
    var fill = function () {
      list.innerHTML = '';
      Array.prototype.forEach.call(select.options, function (o) {
        var li = document.createElement('li');
        li.className = 'af-sort__opt';
        li.setAttribute('role', 'option');
        li.setAttribute('tabindex', '-1');
        li.dataset.v = o.value;
        li.textContent = o.textContent.trim();
        li.setAttribute('aria-selected', o.selected ? 'true' : 'false');
        list.appendChild(li);
      });
      var cur = select.options[select.selectedIndex];
      txt.textContent = cur ? cur.textContent.trim() : '';
    };
    fill();
    var choose = function (v) {
      close(w, true);
      if (select.value === v) return;
      select.value = v;
      fill();
      // The theme sorts on its form's input event, exactly as when the select is used directly. Sent from the form
      // itself, which the theme never redraws, so it still works if the select is redrawn before the theme handles it.
      (select.form || select).dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
    };
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!list.hidden) { close(w, false); return; }
      if (openOne) close(openOne, false);
      fill();
      list.hidden = false;
      box.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      openOne = w;
      var cur = list.querySelector('[aria-selected="true"]') || opts()[0];
      if (cur) cur.focus({ preventScroll: true });
    });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); btn.click(); }
    });
    list.addEventListener('click', function (e) {
      var o = e.target.closest('[role="option"]');
      if (o) choose(o.dataset.v);
    });
    list.addEventListener('keydown', function (e) {
      var l = opts(), i = l.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (l[i + 1] || l[i] || l[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); (l[i - 1] || l[i] || l[0]).focus(); }
      else if (e.key === 'Home') { e.preventDefault(); l[0].focus(); }
      else if (e.key === 'End') { e.preventDefault(); l[l.length - 1].focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (l[i]) choose(l[i].dataset.v); }
      else if (e.key === 'Escape') { e.preventDefault(); close(w, true); }
      else if (e.key === 'Tab') { close(w, false); }
    });
    select.addEventListener('change', fill);
  }

  function scan() { document.querySelectorAll(SEL).forEach(build); }
  document.addEventListener('click', function (e) { if (openOne && !openOne.box.contains(e.target)) close(openOne, false); });

  // Keep every filter tap (Kevin 2026-10-31, "I click one and it unclicks something else"). The theme fetches new
  // results after a tap and redraws the filter list with the ticks it knew when it asked; on a slow phone a tap made
  // while that was loading got wiped (the live site does the same). We remember each tap for a few seconds and put
  // back any tick a late redraw undid, then let the theme fetch again with the full set.
  var intent = {};
  var key = function (i) { return i.name + '=' + i.value; };
  document.addEventListener('change', function (e) {
    var i = e.target;
    if (!i || i.type !== 'checkbox' || !i.closest || !i.closest('facet-filters-form')) return;
    intent[key(i)] = { on: i.checked, t: Date.now() };
  }, true);
  document.addEventListener('click', function (e) {
    // Clear all, Clear and the chosen-filter boxes start fresh, so forget remembered taps.
    if (e.target.closest && e.target.closest('facet-remove, .mobile-facets__clear, .active-facets__button, .facets__reset')) intent = {};
  }, true);
  function replay() {
    var now = Date.now(), fixed = null;
    Object.keys(intent).forEach(function (k) {
      if (now - intent[k].t > 8000) { delete intent[k]; return; }
      document.querySelectorAll('facet-filters-form input[type="checkbox"]').forEach(function (i) {
        if (key(i) === k && i.checked !== intent[k].on) { i.checked = intent[k].on; fixed = i; }
      });
    });
    if (fixed) (fixed.closest('form') || fixed).dispatchEvent(new Event('input', { bubbles: true }));
  }

  // Keep every chosen filter in view (Kevin 2026-11-03, "I picked 3 or 4 designers ... only one of the designers
  // showed"). Once another filter is chosen, Shopify leaves out of the list (and out of the chosen-filter boxes) any
  // chosen value that now has no products. The next tap was then sent without it, so the choice was lost. We put each
  // such value back, ticked and showing 0, with its box, so it stays chosen until the shopper unticks it.
  var rows = {}, fetched = false, uid = 0, saveT = null;
  // Rows seen before (this visit or an earlier one) are remembered in the browser, so a kept choice shows at once on a
  // freshly opened page instead of after reading the whole unfiltered page (measured 5 s on a cold server, 2026-11-03).
  var ROWS_KEY = 'afFilterRows:' + ((window.Shopify && Shopify.theme && Shopify.theme.id) || '');
  try { rows = JSON.parse(localStorage.getItem(ROWS_KEY)) || {}; } catch (e) { rows = {}; }
  function chosen() {
    var out = [];
    new URLSearchParams(location.search).forEach(function (v, k) { if (k.indexOf('filter.') === 0) out.push([k, v]); });
    return out;
  }
  function store(root) {
    var changed = false;
    root.querySelectorAll('facet-filters-form form input[type="checkbox"]').forEach(function (i) {
      var li = i.closest('li'), f = i.closest('form');
      if (!li || !f || i.dataset.afKept) return;
      var k = f.id + '|' + i.name + '|' + i.value;
      if (rows[k] !== li.outerHTML) { rows[k] = li.outerHTML; changed = true; }
    });
    if (changed) {
      clearTimeout(saveT);
      saveT = setTimeout(function () { try { localStorage.setItem(ROWS_KEY, JSON.stringify(rows)); } catch (e) {} }, 1000);
    }
  }
  function loadAll() {
    // A value missing on a freshly opened page: read it from the same page with no filters chosen.
    if (fetched) return;
    fetched = true;
    var grid = document.getElementById('product-grid');
    if (!grid || !grid.dataset.id) return;
    var q = new URLSearchParams();
    new URLSearchParams(location.search).forEach(function (v, k) { if (k.indexOf('filter.') !== 0 && k !== 'page') q.append(k, v); });
    q.set('section_id', grid.dataset.id);
    fetch(location.pathname + '?' + q.toString()).then(function (r) { return r.text(); }).then(function (html) {
      store(new DOMParser().parseFromString(html, 'text/html'));
      keep();
    }).catch(function () {});
  }
  function pillText(fr) {
    var inner = fr.querySelector('.active-facets__button-inner');
    if (!inner) return null;
    for (var n = inner.firstChild; n; n = n.nextSibling) if (n.nodeType === 3 && n.nodeValue.trim()) return n;
    return null;
  }
  function keep() {
    store(document);
    var want = chosen();
    if (!want.length) return;
    var missing = false;
    document.querySelectorAll('facet-filters-form form').forEach(function (form) {
      want.forEach(function (kv) {
        var same = Array.prototype.filter.call(form.querySelectorAll('input[type="checkbox"]'), function (i) { return i.name === kv[0]; });
        if (!same.length || same.some(function (i) { return i.value === kv[1]; })) return;
        var html = rows[form.id + '|' + kv[0] + '|' + kv[1]];
        if (!html) { missing = true; return; }
        var tmp = document.createElement('ul');
        tmp.innerHTML = html;
        var li = tmp.firstElementChild, inp = li && li.querySelector('input');
        if (!inp) return;
        li.classList.remove('hidden');
        inp.checked = true;
        inp.disabled = false;
        inp.dataset.afKept = '1';
        inp.id = 'af-kept-' + (++uid);
        var lab = li.querySelector('label');
        if (lab) { lab.htmlFor = inp.id; lab.classList.remove('disabled'); lab.classList.add('active'); }
        var n = li.querySelector('.af-n'), t = li.querySelector('.facet-checkbox__text-label'), vh = li.querySelector('label > .visually-hidden');
        if (n) n.textContent = '0';
        if (vh && t) vh.textContent = t.textContent.trim() + ' (0 products)';
        var host = same[0].closest('li'), list = host && host.parentNode, on = null;
        if (!list) return;
        same.forEach(function (i) { if (i.checked && i.closest('li')) on = i.closest('li'); });
        list.insertBefore(li, on ? on.nextSibling : list.firstChild);
      });
    });
    if (missing) loadAll();
    // Its chosen-filter box, e.g. "Designer: Eames", removing just that value.
    document.querySelectorAll('facet-filters-form input[data-af-kept]:checked').forEach(function (inp) {
      var g = inp.closest('.js-filter'), gs = g && g.querySelector('summary span'), t = inp.closest('li').querySelector('.facet-checkbox__text-label');
      if (!gs || !t) return;
      var text = gs.textContent.trim() + ': ' + t.textContent.trim(), k = inp.name + '=' + inp.value;
      document.querySelectorAll('.active-facets').forEach(function (box) {
        var all = box.querySelectorAll('facet-remove:not(.active-facets__button-wrapper)');
        if (!all.length) return;
        for (var j = 0; j < all.length; j++) {
          var tn = pillText(all[j]);
          if (all[j].dataset.afKept === k || (tn && tn.nodeValue.trim() === text)) return;
        }
        var pill = all[0].cloneNode(true), a = pill.querySelector('a'), tn2 = pillText(pill);
        if (!a || !tn2) return;
        var q = new URLSearchParams();
        new URLSearchParams(location.search).forEach(function (v, key) { if (!(key === inp.name && v === inp.value)) q.append(key, v); });
        a.href = location.pathname + (q.toString() ? '?' + q.toString() : '');
        tn2.nodeValue = tn2.nodeValue.replace(tn2.nodeValue.trim(), text);
        pill.dataset.afKept = k;
        var after = all[all.length - 1], pre = gs.textContent.trim() + ':';
        for (var m = 0; m < all.length; m++) { var tm = pillText(all[m]); if (tm && tm.nodeValue.trim().indexOf(pre) === 0) after = all[m]; }
        after.after(pill);
      });
    });
  }

  // Fast filter removal (Kevin 2026-11-03: "clear all takes a little while", then "clearing one by one is slow").
  // Measured on the DEV copy: Shopify takes 1 to 4 s to build a set of results the first time and about 0.1 s after
  // that; the page redraws in about 0.08 s. So while filters are on, we fetch in the background, once each, the results
  // the page would show after Clear all and after removing each chosen filter, and hand them over when the theme asks
  // for the same results (a filter box, Clear, Clear all, or unticking the same box: all ask for the same address once
  // its parts are put in order). Asked before one arrives, the theme waits for that same request instead of a new one.
  var pre = {}, order = [];
  var pageFetch = window.fetch;
  function gridId() { var g = document.getElementById('product-grid'); return g && g.dataset.id; }
  function norm(path, query) {
    // Same results whatever the order of the address parts; empty parts (blank price boxes) change nothing.
    var p = [];
    new URLSearchParams(query).forEach(function (v, k) { if (v !== '') p.push([k, v]); });
    p.sort(function (a, b) { return a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : a[1] < b[1] ? -1 : a[1] > b[1] ? 1 : 0; });
    return path + '?' + p.map(function (x) { return encodeURIComponent(x[0]) + '=' + encodeURIComponent(x[1]); }).join('&');
  }
  function keyOf(url) {
    // Only this page's own product grid results (not later pages of the grid, not anything else).
    var u;
    try { u = new URL(url, location.href); } catch (e) { return null; }
    var id = gridId();
    if (!id || u.origin !== location.origin || u.pathname !== location.pathname || u.searchParams.get('section_id') !== id || u.searchParams.has('page')) return null;
    return norm(u.pathname, u.search);
  }
  function get(url, k) {
    if (!pre[k]) {
      pre[k] = pageFetch(url).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); });
      pre[k].catch(function () { delete pre[k]; });
      order.push(k);
      if (order.length > 30) delete pre[order.shift()];
    }
    return pre[k];
  }
  window.fetch = function (input, init) {
    var k = typeof input === 'string' && (!init || !init.method || init.method === 'GET') ? keyOf(input) : null;
    if (!k) return pageFetch.apply(this, arguments);
    return get(input, k).then(function (html) {
      return new Response(html, { status: 200, headers: { 'Content-Type': 'text/html; charset=utf-8' } });
    }, function () { return pageFetch(input, init); });
  };
  // Clear all is fetched together with the single removals, not ahead of them: fetching it first made single removals
  // slow again (Kevin 2026-11-03), so that change was undone.
  function prefetchRemovals() {
    var id = gridId();
    if (!id || !chosen().length) return;
    var sort = new URLSearchParams(location.search).get('sort_by');
    var now = keyOf(location.pathname + '?section_id=' + id + '&' + location.search.slice(1)), started = 0;
    document.querySelectorAll('facet-remove a[href]').forEach(function (a) {
      if (started >= 8) return;
      var i = a.href.indexOf('?'), q = new URLSearchParams(i === -1 ? '' : a.href.slice(i + 1));
      // The same address the theme asks for when this link is clicked (facets.js keeps the current sort).
      if (sort) q.set('sort_by', sort);
      var url = location.pathname + '?section_id=' + id + '&' + q.toString();
      var k = keyOf(url);
      if (k && k !== now && !pre[k]) { started++; get(url, k); }
    });
  }

  // Filtering and sorting redraw parts of the page. Kept choices, remembered taps and sort boxes are put back straight
  // away, before the screen repaints, so nothing flickers (Kevin 2026-11-03: a shake in the sort tray before the sort
  // applied; the theme's own picker showed for a moment while ours waited 50 ms to be rebuilt). Background fetches start
  // just after.
  var t = null;
  new MutationObserver(function () { keep(); replay(); scan(); clearTimeout(t); t = setTimeout(prefetchRemovals, 50); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); keep(); }); else { scan(); keep(); }
  if (document.readyState === 'complete') prefetchRemovals(); else window.addEventListener('load', prefetchRemovals);
})();
